export enum SurgicalOrderStatus {
  ORDER_REGISTERED = 'ORDER_REGISTERED',
  OPME_QUOTATION = 'OPME_QUOTATION',
  CRMO = 'CRMO',
  HEALTH_INSURANCE_APPROVE = 'HEALTH_INSURANCE_APPROVE',
  AUTHORIZED = 'AUTHORIZED',
  SCHEDULED = 'SCHEDULED',
  PRE_SCHEDULE = 'PRE_SCHEDULE',
  CONCLUDED = 'CONCLUDED',
  CHECK_IN = 'CHECK_IN',
  FASTPASS = 'FASTPASS',
  PATIENT_IN_SURGERY = 'PATIENT_IN_SURGERY',
  PATIENT_RECOVERY = 'PATIENT_RECOVERY',
  PATIENT_DISCHARGE = 'PATIENT_DISCHARGE',
  SERVICE_EVALUATION = 'SERVICE_EVALUATION',
  REVIEW = 'REVIEW',
  CANCELLED = 'CANCELLED',
  PENDENCY = 'PENDENCY',
  PENDENT = 'PENDENT',
  IN_PROGRESS = 'IN_PROGRESS',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  CRMO_VALIDATION = 'CRMO_VALIDATION',
  IN_HEALTH_INSURANCE = 'IN_HEALTH_INSURANCE',
  UNSCHEDULED = 'UNSCHEDULED',
  SCHEDULED_AUTHORIZED = 'SCHEDULED_AUTHORIZED',
  SCHEDULED_NOT_AUTHORIZED = 'SCHEDULED_NOT_AUTHORIZED',
  UNSCHEDULED_AUTHORIZED = 'UNSCHEDULED_AUTHORIZED',
  UNSCHEDULED_NOT_AUTHORIZED = 'UNSCHEDULED_NOT_AUTHORIZED',
  DENIED = 'DENIED',
  PARTIALLY_AUTHORIZED = 'PARTIALLY_AUTHORIZED',
  IN_AUTHORIZATION_PROCESS = 'IN_AUTHORIZATION_PROCESS'
  // SURGICAL_PACKAGE = 'SURGICAL_PACKAGE' // TODO: Review
}

export enum SurgicalOrderStatusReturnEnum {
  CANCELLATION_REQUEST = 'Solicitação de cancelamento',
  CANCELLED = 'Cancelada'
}
